import React from 'react';
import { FaFacebookF, FaYoutube } from 'react-icons/fa';
import csi from '../assets/csi.png';
import footerChurch from '../assets/footer_sunset_church.jpg';

export default function Footer({ activeSection = 'home', onSelectSection = () => { } }) {
  return (
    <footer className="bg-[#140e26] text-white relative overflow-hidden font-sans border-t border-[#261b42]">

      {/* Background Sunset Church on Far Right */}
      <div className="absolute right-0 top-0 bottom-0 w-full md:w-3/5 lg:w-1/2 pointer-events-none z-0">
        <img
          src={footerChurch}
          alt="Cathedral Sunset"
          className="w-full h-full object-cover object-right filter brightness-90 contrast-105"
        />
        {/* Smooth gradient fading into dark midnight purple */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#140e26] via-[#140e26]/85 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#140e26] via-transparent to-[#140e26]/40"></div>
      </div>

      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-14 relative z-10">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8 lg:gap-10">

          {/* Left Brand Section */}
          <div className="w-full lg:w-[320px] shrink-0">
            {/* White Logo Card */}
            <div className="bg-white rounded-lg p-3 sm:p-3.5 shadow-[0_8px_25px_rgba(0,0,0,0.3)] inline-flex items-center gap-3.5 border border-white/40">
              <div className="w-12 h-12 shrink-0 flex items-center justify-center">
                <img src={csi} alt="CSI Emblem" className="w-full h-full object-contain" />
              </div>
              <div className="flex flex-col justify-center pr-2">
                <span className="font-serif text-[9px] tracking-wider text-[#842343] uppercase font-bold leading-none mb-1">
                  CSI DIOCESE OF
                </span>
                <span className="font-serif font-extrabold text-[#842343] text-[20px] sm:text-[22px] leading-none tracking-tight">
                  MALABAR
                </span>
                <span className="font-serif text-[7.5px] tracking-widest text-[#1a1715] uppercase font-bold mt-1 leading-none">
                  CHURCH OF SOUTH INDIA
                </span>
              </div>
            </div>

            {/* Tagline */}
            <p className="text-[13px] sm:text-[14px] text-white/90 leading-relaxed font-normal mt-4 mb-5 max-w-[290px]">
              We are a community of believers proclaiming the Gospel and serving humanity.
            </p>

            {/* Social Media Icons */}
            <div className="flex items-center gap-3">
              <a
                href="https://www.facebook.com/malabardiocese"
                target="_blank"
                rel="noreferrer"
                className="w-8 h-8 rounded-full bg-white text-[#1877F2] hover:scale-110 flex items-center justify-center shadow-md transition-transform duration-300"
                title="Facebook"
              >
                <FaFacebookF className="w-4 h-4" />
              </a>
              <a
                href="https://www.youtube.com/@csidioceseofmalabar409"
                target="_blank"
                rel="noreferrer"
                className="w-8 h-8 rounded-full bg-[#FF0000] text-white hover:scale-110 flex items-center justify-center shadow-md transition-transform duration-300"
                title="YouTube"
              >
                <FaYoutube className="w-4 h-4" />
              </a>
              {/* <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="w-8 h-8 rounded-full bg-gradient-to-tr from-[#f09433] via-[#dc2743] to-[#bc1888] text-white hover:scale-110 flex items-center justify-center shadow-md transition-transform duration-300"
                title="Instagram"
              >
                <FaInstagram className="w-4 h-4" />
              </a> */}
              {/* <a
                href="https://twitter.com"
                target="_blank"
                rel="noreferrer"
                className="w-8 h-8 rounded-full bg-[#1DA1F2] text-white hover:scale-110 flex items-center justify-center shadow-md transition-transform duration-300"
                title="Twitter"
              >
                <FaTwitter className="w-4 h-4" />
              </a> */}
            </div>
          </div>

          {/* Thin Vertical Divider */}
          <div className="hidden lg:block w-[1px] bg-white/15 self-stretch min-h-[160px]"></div>

          {/* 4 Link Columns Grid */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 lg:gap-10 flex-1 w-full">

            {/* Column 1: Explore */}
            <div className="space-y-3">
              <h4 className="font-serif font-bold text-white text-[16px] sm:text-[17px] tracking-wide mb-3">
                Explore
              </h4>
              <ul className="space-y-2 text-[13px] text-white/80">
                {[
                  { label: 'About Us', key: 'about' },
                  { label: 'Parishes', key: 'churches' },
                  { label: 'Events', key: 'events' },
                  { label: 'News & Media', key: 'news' },
                  { label: 'Publications', key: 'publications' },
                ].map((item, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => onSelectSection(item.key)}
                      className="hover:text-[#E5C98B] hover:translate-x-1 transition-all duration-200 block text-left"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 2: Services */}
            <div className="space-y-3">
              <h4 className="font-serif font-bold text-white text-[16px] sm:text-[17px] tracking-wide mb-3">
                Services
              </h4>
              <ul className="space-y-2 text-[13px] text-white/80">
                {[
                  { label: 'Prayer Request', key: 'contact' },
                  { label: 'Daily Readings', key: 'readings' },
                  { label: 'Live Streaming', key: 'live' },
                  { label: 'Newsletter', key: 'contact' },
                  { label: 'Contact Us', key: 'contact' }
                ].map((item, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => onSelectSection(item.key)}
                      className="hover:text-[#E5C98B] hover:translate-x-1 transition-all duration-200 block text-left"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 3: Institutions */}
            <div className="space-y-3">
              <h4 className="font-serif font-bold text-white text-[16px] sm:text-[17px] tracking-wide mb-3">
                Institutions
              </h4>
              <ul className="space-y-2 text-[13px] text-white/80">
                {[
                  { label: 'Schools', key: 'schools' },
                  { label: 'Colleges', key: 'colleges' },
                  { label: 'Hospitals', key: 'hospitals' },
                  { label: 'Retreat Centres', key: 'retreat' },
                  { label: 'Social Services', key: 'socialboard' },
                  { label: 'Bookshop', key: 'bookshop' }
                ].map((item, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => onSelectSection(item.key)}
                      className="hover:text-[#E5C98B] hover:translate-x-1 transition-all duration-200 block text-left"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Help */}
            <div className="space-y-3">
              <h4 className="font-serif font-bold text-white text-[16px] sm:text-[17px] tracking-wide mb-3">
                Help
              </h4>
              <ul className="space-y-2 text-[13px] text-white/80">
                {[
                  { label: 'FAQs', key: 'contact' },
                  { label: 'Privacy Policy', key: 'contact' },
                  { label: 'Terms & Conditions', key: 'contact' },
                  { label: 'Sitemap', key: 'sitemap' },
                  { label: 'Support', key: 'contact' }
                ].map((item, idx) => (
                  <li key={idx}>
                    <button
                      onClick={() => onSelectSection(item.key)}
                      className="hover:text-[#E5C98B] hover:translate-x-1 transition-all duration-200 block text-left"
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>

          </div>

        </div>

        {/* Bottom Copyright Bar */}
        <div className="relative z-20 pt-6 mt-8 border-t border-white/20 flex items-center justify-center text-center">
          <p className="text-[#F3E5AB] font-bold text-sm sm:text-[15px] tracking-wider text-center drop-shadow-md py-2 px-6 ">
            © 2026 Church of South India. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
}
